module.exports = __webpack_public_path__ + "static/img/people-logo-2.f707140.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/people-logo-2.png
// module id = hmRy
// module chunks = 49